export interface SelectItem<T> {
  value: T;
  label: string;
}
